// extracted by mini-css-extract-plugin
export var copyableField = "_i5-4";
export var customerBadge = "_i5-0";
export var customerInfoTitle = "_i5-2";
export var details = "_i5-1";
export var dropdownContainer = "_i5-5";
export var dropdownImage = "_i5-6";
export var editAssigneeForm = "_i5-a";
export var editButton = "_i5-3";
export var email = "_i5-7";
export var hidden = "_i5-d";
export var input = "_i5-8";
export var saveButton = "_i5-b";
export var shopifyIcon = "_i5-c";
export var suggestionBadge = "_i5-e";
export var suggestionText = "_i5-f";
export var username = "_i5-9";